import React from "react";
import { Link } from "react-router-dom";
import { MagnifyingGlass, House } from "@phosphor-icons/react";

export default function NotFound() {
  return <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
    <div className="w-full max-w-lg bg-white border border-slate-200 p-7 sm:p-10 text-center shadow-sm">
      <div className="text-xs font-mono font-bold tracking-[0.3em] text-blue-600">404</div>
      <MagnifyingGlass size={44} weight="duotone" className="mx-auto mt-4 text-slate-400"/>
      <h1 className="text-2xl font-extrabold mt-3">Sayfa bulunamadı</h1>
      <p className="mt-2 text-sm text-slate-500 leading-6">Bağlantı değişmiş, kayıt kaldırılmış veya bu sayfaya erişim yetkiniz olmayabilir.</p>
      <Link to="/app" className="mt-6 inline-flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-5 py-2.5 font-semibold text-sm"><House size={17}/>Dashboard'a Dön</Link>
    </div>
  </div>;
}
